import { Button, Grid, TextField,Paper } from '@mui/material';
import { useFormik } from 'formik';
import {React, useEffect, useState} from 'react'
import * as yup from 'yup';

export default function RedemptionPartnerForm(props)
{
    const[imageName,setImageName] = useState(null);   
    const[isAddOperation,setIsAddOperation] = useState(false);
    const[recvValues,setRecvValues] = useState({ id:'', redemptionPartnerName:'',
    partnerWholesaleBrandName:'',
    retailerBrandName:'',
    
    contact:'',
    });
    useEffect(()=>{

       if(props.selectedRow !== null )//&& valueLoaded === false)
       {
            console.log("RPartner Edit"+JSON.stringify(props.selectedRow));
            setRecvValues({
                id:props.selectedRow.id,
                redemptionPartnerName:props.selectedRow.name,
                partnerWholesaleBrandName:props.selectedRow.parent_wholesale_brand,
                retailerBrandName:props.selectedRow.retailer_brand_name,
                
                contact:props.selectedRow.key_contacts,
                
            });
            setImageName(props.selectedRow.logo);
            setIsAddOperation(false);
        }
        else
        {
            setRecvValues({  id:'',redemptionPartnerName:'',
            partnerWholesaleBrandName:'',
            retailerBrandName:'',
            
            contact:'',
            });
            setIsAddOperation(true);
            setImageName("");
        }

    },[props.selectedRow]);
    
    const validationSchema = yup.object({
        redemptionPartnerName: yup
            .string("AAA")
          .required('Partner is required'),
        
      });
      function onCancelForm()
      {
          //alert("Cancel");
          props.handleSubmit(null,isAddOperation,true)
      }
   
    const formik = useFormik({
        enableReinitialize:true,
        validationSchema: validationSchema,
        initialValues:{
            id:recvValues?.id || '',
            redemptionPartnerName:recvValues?.redemptionPartnerName || '',
            partnerWholesaleBrandName:recvValues?.partnerWholesaleBrandName || '',
            retailerBrandName:recvValues?.retailerBrandName || '',
            
            contact:recvValues?.contact || ''
            
        },

        onSubmit:(values)=>{
        
            if(values.redemptionPartnerName === '')
                props.handleSubmit(null,isAddOperation,true);
            else
            {

                props.handleSubmit(values,isAddOperation,false);
            }
           //this.resetForm();

        },
        // onReset:(values)=>{
        //     alert("Onreset");

        //     props.handleSubmit(null,isAddOperation,true)
        // }
    });

    return(
        // <Grid style={{ borderStyle: 'solid', borderColor: 'pink' }} container item spacing={3} xs={12}
        // direction="column" alignItems='flex-start' >
            // <Paper >
            <form onSubmit={formik.handleSubmit} >
                {/* <Grid container spacing={2}> */}
                    <Grid item container xs={12} spacing={2}
                    justifyContent="flex-start" style={{ borderStyle: 'none', borderColor: 'black' }}
                    alignItems='flex-start' direction="row">
                {/* <Grid container spacing={{xs:2,md:5}} direction="row" columns={{xs:4,sm:8,md:12}}> */}
                            <Grid item xs={12} sm={12} md={12}  >
                            </Grid>
                            <Grid item  xs={12} sm={4} md={5}  >
                                <TextField
                                    fullWidth
                                    variant='outlined'
                                    id="redemptionPartnerName"
                                    name="redemptionPartnerName"
                                    label="Name"
                                    value={formik.values.redemptionPartnerName}
                                    onChange={formik.handleChange}
                                    error={formik.touched.redemptionPartnerName && Boolean(formik.errors.redemptionPartnerName)}
                                    helperText={formik.touched.redemptionPartnerName && formik.errors.redemptionPartnerName}
                                />
                            </Grid>
                            {/* <Grid item xs={12} sm={4} md={5}  >
                                <TextField
                                    fullWidth
                                    variant='outlined'
                                    id="partnerlocation"
                                    name="location"
                                    label="Location"
                                    value={formik.values.location}
                                    onChange={formik.handleChange}
                                    error={formik.touched.location && Boolean(formik.errors.location)}
                                    helperText={formik.touched.location && formik.errors.location}
                                />
                            </Grid> */}
                            <Grid item xs={12} sm={4} md={5}  >
                                <TextField
                                    fullWidth
                                    variant='outlined'
                                    id="partnerContact"
                                    name="contact"
                                    label="Contact"
                                    value={formik.values.contact}
                                    onChange={formik.handleChange}
                                    error={formik.touched.contact && Boolean(formik.errors.contact)}
                                    helperText={formik.touched.contact && formik.errors.contact}
                                />
                            </Grid>
                    </Grid>
                    <Grid container item xs={12}
                    direction="row" spacing={3}
                    style={{ borderStyle: 'none', borderColor: 'black', marginTop: 16 }} justifyContent='flex-start'>
                        <Grid item >
                            <Button type='submit' color='primary' variant='contained'>Submit</Button>
                        </Grid>
                        <Grid item>
                            <Button type='button' onClick={onCancelForm}  color='secondary' variant='contained'>Cancel</Button>
                        </Grid>
                    </Grid>
                {/* </Grid> */}
            </form>
            // </Paper>
        // </Grid>


    );
}